





















import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import {STreeData} from "./dto/STreeData";
import {STreeItem} from "./dto/STreeItem";
import ClickOutside from 'vue-click-outside';
@Component({
  directives: {
    ClickOutside,
  },
})
export default class SearchTreeItem extends Vue {
  @Prop() treeData!: STreeData;
  private searchProp: string = '';
  private optionsVisible = false;
  private options: STreeItem[] = [];

  @Watch('searchProp')
  WatchsearchProp(newValue: string){
    this.options = this.fiteredItem(newValue, this.treeData.treeItems);
    if(newValue.trim() !== ""){
      this.openOptions();
    }else {
      this.closeOptions();
    }
  }

  fiteredItem(findValue: string, item : STreeItem[]): STreeItem[]{
    let data: STreeItem[] = [];
    item.map(item => {
      const nameAndValue = `${item.propName.toLowerCase()}:${String(String(item.propValue).toLowerCase())}`;
      if(item.propName.toLowerCase().includes(findValue.toLowerCase()) ||
          String(String(item.propValue).toLowerCase()).includes(findValue.toLowerCase()) ||
          nameAndValue.includes(findValue.replace(' ', '').toLowerCase())){
        data.push(item);
      }
      if(item.propChildren.length > 0){
        data.push(...this.fiteredItem(findValue,item.propChildren));
      }
    })
    return data;
  }

  @Emit('selectedItem')
  EmitSelectedOption(item: STreeItem) {
    this.closeOptions();
    const searchValue = item.propChildren.length > 0 ? '' : item.propValue;
    this.searchProp = `${item.propName}: ${searchValue}`;
    return item;
  }
  @Emit('handleClickOutside')
  handleClickOutside(){
    this.closeOptions();
  }

  handleClickInput(){
    if(this.options.length > 0){
      this.openOptions();
    }
  }

  openOptions() {
    this.optionsVisible = true;
  }

  closeOptions() {
    this.optionsVisible = false;
  }
}
